import { render, staticRenderFns } from "./stakeInput.vue?vue&type=template&id=29bbd458&lang=pug&"
import script from "./stakeInput.vue?vue&type=script&lang=js&"
export * from "./stakeInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports